import React from 'react'
import './style.scss'
import {Card, Icon} from 'antd'
class Contact extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        return(
            <div className="contact-container">
                
                <div className="contact-info">
                    <Card className="info-card">
                        <div className="info-wrap">
                        <Icon className="phone-i" type="phone" />
                        <p>
                            +46 70 270 83 85
                        </p>
                        </div>
                        <div className="info-wrap">
                            <Icon className="email-i" type="mail" />
                            <p>
                                lennart@isundgrensakeri.se
                            </p>
                        </div>
                    </Card>
                </div>
                <div className="googlemap">
                    <iframe title="map"src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1921.333438234927!2d17.141384916213582!3d61.212719165642966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466132d01c1436b3%3A0xdfabc40d6708765f!2sV%C3%A5rdbergsv%C3%A4gen%2016%2C%20820%2020%20Ljusne%2C%20Sverige!5e0!3m2!1sno!2sno!4v1589062640511!5m2!1sno!2sno" width="600" height="450" frameborder="0" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> 
                </div>
            </div>
        )
    }
}
export default Contact;